import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete, ticketSendToCheck, fetchPublish } from "@/api/PMS/performancecenter/theaterManage";
import { fetchActiOffline } from "@/api/PMS/communityPartyBuilding/activityManage";
import waves from "@/directive/waves"; // 水波纹指令

import activeAdd from "./add";
import configList from './configList'; // import signUpQuestion from "./signUpQuestion.vue";

export default {
  name: "ComplexTable",
  components: {
    activeAdd: activeAdd,
    // signUpQuestion,
    configList: configList
  },
  directives: {
    waves: waves
  },
  props: {
    isDashboard: Boolean
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        activityTypeIds: [4]
      },
      title: "",
      receiverObjectType: "",
      id: -1,
      activityAuditStatus: null,
      // tableRow: null,
      dates: [],
      isDetail: false,
      // 是否是查看
      isAudit: false,
      // 是否是审核
      multipleSelection: [],
      dialogFormVisible: false,
      dialogFormViewListVisible: false,
      dialogFormDetailVisible: false,
      dialogPlacePriceFormVisible: false // dialogVisible: false

    };
  },
  computed: {
    isBuildParty: function isBuildParty() {
      return this.$route.path.indexOf("partyactivityManage") > -1;
    }
  },
  created: function created() {
    // 获取路由的配置
    var appType = this.$route.query.appType;

    if (appType !== undefined) {
      this.listQuery.appType = parseInt(appType);
    }

    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false; // this.dialogVisible = false;

      this.dialogPlacePriceFormVisible = false;
    },
    handDetailCancle: function handDetailCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormDetailVisible = false;
    },
    handViewListCancle: function handViewListCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormViewListVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = "";
        this.listQuery.endDate = "";
      } // if (this.isBuildParty || this.isDashboard) {
      //   this.listQuery.appType = 0;
      // } else {
      //   this.listQuery.appType = 1;
      // }


      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    isActiveOver: function isActiveOver(activeTime) {
      var overTime = new Date(activeTime).getTime() + 16 * 3600 * 1000; // 活动结束时间

      if (activeTime && new Date().getTime() > overTime) {
        return true;
      } else {
        return false;
      }
    },
    // 创建 
    handleCreate: function handleCreate() {
      this.id = -1;
      this.title = "创建";
      this.isDetail = false;
      this.isAudit = false;
      this.dialogFormVisible = true;
    },
    getRelease: function getRelease(id) {
      var _this2 = this;

      this.$confirm("你确定是要发布这条活动吗, 是否继续?", "提示").then(function () {
        fetchPublish({
          id: id
        }).then(function (res) {
          if (res.data.code === 200) {
            _this2.getList();

            _this2.Alert({
              alertType: "update",
              message: "发布成功"
            });
          }
        });
      });
    },
    getOffline: function getOffline(id) {
      var _this3 = this;

      this.$confirm("你确定是要下架这条活动吗, 是否继续?", "提示").then(function () {
        fetchActiOffline({
          id: id
        }).then(function (res) {
          if (res.data.code === 200) {
            _this3.getList();

            _this3.Alert({
              alertType: "update",
              message: "下架成功"
            });
          }
        });
      });
    },
    // 编辑
    handleUpdate: function handleUpdate(id) {
      this.id = id;
      this.title = "编辑";
      this.isDetail = false;
      this.isAudit = false;
      this.dialogFormVisible = true;
    },
    delete: function _delete(ids) {
      var _this4 = this;

      if (ids.length > 0) {
        this.$confirm("你确定是要删除本条活动吗, 是否继续?", "提示").then(function (res) {
          fetchDelete({
            ids: ids,
            appType: _this4.listQuery.appType
          }).then(function (response) {
            if (response.data.code == 200) {
              _this4.getList();

              _this4.Alert({
                alertType: "delete"
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    handleDelete: function handleDelete(id) {
      var ids = [];
      ids.push(id);
      this.delete(ids);
    },
    handleDeletes: function handleDeletes() {
      var Ids = [];
      this.multipleSelection.forEach(function (row) {
        Ids.push(row.id);
      });
      this.delete(Ids);
    },
    handleCheck: function handleCheck(id) {
      this.isAudit = false;
      this.isDetail = true;
      this.id = id;
      this.title = "查看";
      this.dialogFormVisible = true;
    },
    handleConfig: function handleConfig(id, activityAuditStatus) {
      this.id = id;
      this.activityAuditStatus = activityAuditStatus;
      this.title = "场次配置";
      this.dialogPlacePriceFormVisible = true;
    },
    // handleSignUp (row) {
    //   let { id, activityTitle } = row;
    //   this.id = id;
    //   this.tableRow = row;
    //   this.title = activityTitle + "报名情况";
    //   this.dialogVisible = true;
    // },
    handleExamine: function handleExamine(id) {
      var _this5 = this;

      this.$confirm("你确定是要提交审核吗, 是否继续?", "提示").then(function (res) {
        ticketSendToCheck({
          id: id
        }).then(function (response) {
          if (response.data.code === 200) {
            _this5.getList();

            _this5.Alert({
              alertType: "update",
              message: "提交成功"
            });
          }
        });
      }); // this.isAudit = true;
      // this.isDetail = true;
      // this.id = id;
      // this.title = "审核";
      // this.dialogFormVisible = true;
    },
    // 详情
    getDetail: function getDetail(id) {
      this.id = id;
      this.isDetail = true;
      this.title = "详情";
      this.dialogFormVisible = true;
    }
  }
};